<template>
  <div class="dashboard-container">
    <!-- 客资管理---成单客资 -->
    <div class="app-container">
      <el-card shadow="never">
        <el-form :inline="true" class="demo-form-inline">
          
         
          <el-form-item label="销售:">
            <el-select v-model="inputAcount" filterable  clearable  placeholder="请选择销售">
              <el-option v-for="item in optionsList1" :key="item.saleId" :label="item.label"
                :value="item.saleId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select v-model="trafficSource" filterable clearable placeholder="请选择状态">
              <el-option label="有效" value="1"></el-option>
              <el-option label="无效" value="2"></el-option>
            </el-select>
          </el-form-item>
         
        </el-form>

        <div style=" text-align: end; padding: 0px 0px 20px 0px;">
            <el-button type="primary" @click="handleSearch1('','1')" size="small" class="btns" icon="el-icon-plus">新增</el-button>
            <el-button @click="handleClear" icon="el-icon-close" size="small" class="btns">清除</el-button>
            <el-button type="primary" @click="handleSearch" size="small" class="btns"  icon="el-icon-search">搜索</el-button>
            <!-- <el-button type="primary" icon="el-icon-download" size="small" class="btns" @click="handleDownload">导出</el-button> -->
        </div>

        <!-- 查询列表 -->
        <el-table :header-cell-style="{'text-align':'center', background: '#fafafa', }" :cell-style="{'text-align':'center'}" :data="list" border height="700"  v-loading="tableLoading"  element-loading-text="加载中...">
          
          <el-table-column :resizable="false" prop="saleName" label="销售"> </el-table-column>
          <el-table-column :resizable="false" prop="saleType" label="状态">
            <template v-slot="scope">
              <span v-if="scope.row.saleType === 1">有效</span>
              <span v-if="scope.row.saleType === 2">无效</span>
            </template>
          </el-table-column>
          <el-table-column :resizable="false" prop="saleWeight" label="权重"></el-table-column>
          <el-table-column header-align="center" label="操作" width="200px">
            <template v-slot="scope">
              <el-button type="text"  @click="handleSearch1(scope.row,'2')">编辑</el-button>
              <el-button type="text" @click="handleSearch1(scope.row,'3')">详情</el-button>
              <el-button type="text" @click="handleSearch1(scope.row,'4')" style="color: red;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 图片弹层 -->
        <el-dialog :visible="previewDialogVisible" width="60%" class="custom-dialog">
          <img :src="previewImageUrl" style="max-width: 100%; max-height: 100%" />
        </el-dialog>
        <!--         分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="requestParameters.currentpage" :page-size="requestParameters.pagesize"
          layout="prev, pager, next,sizes, jumper" :total="total" style="margin-top: 20px;">
        </el-pagination>
        <!--        成单编辑弹窗-->
        <order-update ref="orderUpdate" @refreshOrder="refreshOrder"  CustomerFundingType="退费"></order-update>
        <!--        成单客资详情页面-->
        <order-detail ref="orderDetail"></order-detail>
      </el-card>
    </div>


    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="绑定问卷"  :visible="showDing" :before-close="closeEditDialogs" width="33%">

      <div>
        <div style="margin-bottom: 10px;">绑定问卷: 测试问卷</div>
        <div>绑定提交人: 测试提交人</div>
      </div>

      <div  class="dialog-footer" style="text-align: end;">
        <div style="text-align: end;">
          <el-button size="small" @click="showDing = false">取 消</el-button>
          <el-button size="small" type="primary" @click="handleBinding">确 定</el-button>
        </div>
      </div>
    </el-dialog>



    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" :title="isnewModesCustomerFundingDetailsTitle"  :visible="isnewModesCustomerFundingDetails" :before-close="isnewModesCustomerFundingDetailscloseEditDialogs" width="60%">

        <el-form >
          <el-form-item label="销售:">
            <el-select v-model="input1" filterable  clearable  placeholder="请选择销售" style="width: 100%;" :disabled="isnewModesCustomerFundingDetailsDetail" :filter-method="handleChangeNameaaaa" >
              <el-option v-for="item in optionsListss" :key="item.id" :label="item.realname" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="权重:">
            <el-input v-model="input2" filterable clearable placeholder="请选择状态" style="width: 100%;" :disabled="isnewModesCustomerFundingDetailsDetail"></el-input>
          </el-form-item>

          <el-form-item label="状态:">
            <el-select v-model="input3" filterable clearable placeholder="请选择状态" style="width: 100%;" :disabled="isnewModesCustomerFundingDetailsDetail">
              <el-option label="有效" :value="1"></el-option>
              <el-option label="无效" :value="2"></el-option>
            </el-select>
          </el-form-item>
         
        </el-form>

      <div  class="dialog-footer" style="text-align: end;">
        <div style="text-align: end;">
          <el-button size="small" @click="isnewModesCustomerFundingDetailscloseEditDialogs">取 消</el-button>
          <el-button size="small" type="primary" :disabled="isnewModesCustomerFundingDetailsDetail" @click="isnewModesCustomerFundingDetailsSibutleForm">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    


    <newModesCustomerFundingDetail v-if="isnewModesCustomerFundingDetail" ref="newModesCustomerFundingDetail" @newModesCustomerFundingDetailEvent="newModesCustomerFundingDetailEvent" typeCustomerFunding="退费" isUrView="/orderCustomer/updateReturnPremium"></newModesCustomerFundingDetail>

  </div>
</template>
<script>
import apiBaseUrl from "../../config/api";
import axios from "axios";
// import CustomerUpdOrDet from './components/CustomerUpdOrDet.vue';
import OrderUpdate from "./OrderUpdate.vue";
import OrderDetail from "./OrderDetail.vue";
import newModesCustomerFundingDetail from "./newModesCustomerFundingDetail.vue";
export default {
  components: {
    OrderDetail,
    OrderUpdate, //成单编辑
    newModesCustomerFundingDetail,
  },
  data () {
    return {

       urls:'',
       ids:'',
       types:'',

      isnewModesCustomerFundingDetails:false,
      isnewModesCustomerFundingDetailsDetail:false,
      isnewModesCustomerFundingDetailsTitle:'',


      input1:'',
      input2:'',
      input3:'',


      searchSourcesPeople11:'',
      sourcesPeople11:[],
      searchSourcesPeople111:'',
      sourcesPeople111:[],

      tableLoading: false,
      optionsListtt:[
        {dictValue:"规划", dictType:1 },
        {dictValue:"线下", dictType:2 },
        {dictValue:"纯补课", dictType:3 },
      ],
      props: {
        label: "categoryName",
        children: "children",
        value: "id"
      },
      isnewModesCustomerFundingDetail: false,
      grade:[],
      trafficSource:'',
      inputAcount:"",
      optionsList:[ ],
      optionsList1:[ ],
      classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
      classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' },{ value: 4, label: '流失' }],
      state: "",
      classType: '',
      customerId: "",//订单号
      isRenew: "",
      offlineStatus: "",
      onlineStatus: "",
      orderStatuss: "",//订单状态
      customerPaytime: "",//付款时间
      offlineStatuss: [
        {
          value: 1,
          label: '是'
        }, {
          value: 2,
          label: '否'
        },
      ],
      onlineStatuss: [
        {
          value: 1,
          label: '是'
        }, {
          value: 2,
          label: '否'
        },
      ],
      isRenews: [
        {
          value: 1,
          label: '是'
        }, {
          value: 2,
          label: '否'
        },
      ],
      parentPhoneNumber: "",
      orderTypes: [
        {
          value: 1,
          label: '待退费'
        }, {
          value: 2,
          label: '已退费'
        },
        {
          value: 3,
          label: '恢复上课'
        },
      ],
      channelType:'',
      DealTypeListt: [
        {
          value: 1,
          label: "线上",
        },
        {
          value: 2,
          label: "线下",
        },
        {
          value: 3,
          label: "转介绍",
        },

      ],
      DealTypeList: [
        {
          value: 1,
          label: "定金",
        },
        {
          value: 2,
          label: "全额",
        },
        {
          value: 3,
          label: "分期",
        },
      ],
      teachers: [
        {
          value: 1,
          label: "小单老师",
        },
        {
          value: 2,
          label: "大单老师",
        },
        {
          value: 3,
          label: "刘老师",
        },
        {
          value: 4,
          label: "杨老师",
        },
      ], //；老师
      customerIsallpay: "",//尾款付费情况
      sources: [], //客资来源列表
      sourcesPeople: [], //客资来源负责人列表
      list: [],
      address: "",
      total: 0, //总条数
      url: "",
      searchWx: "", // 输入的微信号
      searchStudent: "", //输入的学生姓名
      searchTeacherId: "", //选择的老师姓名
      orderType: "", // 请选择状态
      createTimes: [], // 创建时间
      createTimess: [], // 创建时间
      createTimesss: [], // 创建时间
      paymentTime: "", // 付款时间
      searchSourcesPeople: "", //选择的来源负责人
      searchAdd: "", //选择添加方式
      selectedState: "",
      searchSource: "", //选择来源
      stateList: [],
      d: [],
      studentName: "", // 保存学生姓名的变量
      deleteCustomerId: null,
      searchKeyword: "",
      requestParameters: {
        pagesize: 10, //每页多少条
        currentpage: 1, //当前显示页码
      },
      showEdit: false, // 控制弹层显示/隐藏的变量
      srcList: [], // 预览图像的原始链接列表
      previewImageUrl: "", // 当前预览图像的链接
      previewDialogVisible: false, // 大图预览对话框是否可见
      regionName:"",
      optionsListt:[
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ],

      showDing:false,
      categoryList: [],

      optionsListss: [],

    };
  },
  mounted () {
    this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj'))
    this.optionsList1 = JSON.parse(sessionStorage.getItem('customersaleObj1'))

    this.sourcesPeople111 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))
    this.sourcesPeople11 = JSON.parse(sessionStorage.getItem('diagnoseTeacherFindList'))

    axios.get(`${apiBaseUrl}/category/list`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      this.categoryList = res.data.data;
    }).catch(error => {
      this.$message({
        message: "获取课程列表失败",
        type: "error"
      });
    })


    axios.post(`${apiBaseUrl}/schedule/teacherListByName`, { realname: '' },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
         if (res.data.code == 200) {
           let datas = res.data.data
           this.optionsListss = datas
         }else{
           this.optionsListss = JSON.parse(sessionStorage.getItem('customersaleObj1'))
         }
    })

  },
  created () {
    this.getList();
    // this.getDataSourse();
    // this.getDataSoursePeople();
    this.getcityOptions()


  },
  methods: {

    handleChangeNameaaaa(value) {
      if (value) {
        axios.post(`${apiBaseUrl}/schedule/teacherListByName`, { realname: value },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
            let datas = res.data.data
            this.optionsListss = datas
          }else{
            this.optionsListss = JSON.parse(sessionStorage.getItem('customersaleObj1'))
          }
        })
      } else {
        this.optionsListss = JSON.parse(sessionStorage.getItem('customersaleObj1'))
      }
    },


    getcityOptions(){
      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
      { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
      }).then((res)=>{ this.optionsListt = res.data.data})
    },

    handleBinding(){
      this.$confirm('绑定后，将更新学生相关信息，是否确认进行绑定?', '提示', {  confirmButtonText: '确定',  cancelButtonText: '取消',  type: 'warning'}).then(() => {
        this.$notify({title: '成功', message: '绑定成功~', type: 'success'  })
        // this.$notify.error({ title: '错误',message: '绑定失败~' })
        this.showDing = false
      })
    },
    closeEditDialogs(){
      this.showDing = false
    },
    details(){
      this.showDing = true
    },
    //查询列表
    getList () {
      const data = {

        pageNum: this.requestParameters.currentpage,
        pageSize: this.requestParameters.pagesize,
        saleId:this.inputAcount, 
        saleType:this.trafficSource,

      };
     

      this.tableLoading = true

      // axios.post(`${apiBaseUrl}/orderCustomer/list`, data,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then((response) => {
      axios.post(`${apiBaseUrl}/saleWeight/findPage`, data,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then((response) => {
        this.tableLoading = false    
        if(response.data.code === -1){
            this.$message({ message: response.data.message ,type: 'error' })
            this.list = [];
            this.total = 0;
        }else{
            this.$message({ message: response.data.message ,type: 'success' })
            this.list = response.data.data.records;
            this.total = response.data.data.total; // 更新总条数
       }
      }).catch((error) => {
          this.tableLoading = false    
          this.$message({ message: error, type: 'error' })
      })
    },
    //客资来源
    getDataSourse () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then((response) => {
          this.sources = response.data.data.list;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //客资来源负责人
    getDataSoursePeople () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then((response) => {
          this.sourcesPeople = response.data.data.list;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //查询状态
    handleStateChange (row) {
      const { customerId, customerState } = row; // 获取当前行的 ID 和选中的值
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstateupdate`, {
          customerId: customerId,
          customerState: customerState,
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((response) => {
          console.log(response);
          // 更新数据成功后，进行相应的操作
          this.stateList = response.data.data;
          if (response.data.code === 200) {
            this.$message({
              message: "客资状态保存成功",
              type: "success",
              duration: 1000,
            });
            this.getList();
          } else {
            //失败
            this.$message({
              error: "客资状态未保存",
              type: "error",
              duration: 1000,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //添加方式：主动/被动
    handleAddChange (row) {
      const { customerId, customerIsactive } = row; // 获取当前行的 ID 和选中的值
      axios
        .put(`${apiBaseUrl}/customerinformation/customerisactiveupdate`, {
          customerId: customerId,
          customerIsactive: customerIsactive,
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((response) => {
          console.log(response);
          // 更新数据成功后，进行相应的操作
          this.addList = response.data.data;
          if (response.data.code === 200) {
            this.$message({
              message: "添加方式保存成功",
              type: "success",
              duration: 1000,
            });
            this.getList();
          } else {
            //失败
            this.$message({
              error: "添加方式保存未保存",
              type: "error",
              duration: 1000,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    resetSuccesType (customer) {
      customer.type = 1;
    },

    //删除
    deleteCustomer (customerId) {
      this.$confirm("确定删除该条客资信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(
              `${apiBaseUrl}/customerinformation/customerdelete/${customerId}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
            )
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                this.$message.success("删除成功");
                this.getList();
              } else {
                //失败
                this.$message.error("删除失败");
              }
            })
            .catch((error) => {
              console.log(error);
              this.$message.error("删除失败");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //图片预览
    handlePreview (url) {
      if (!this.srcList.includes(url)) {
        this.srcList.push(url);
      }
      this.previewImageUrl = url;
      this.previewDialogVisible = true;
    },
    //分页
    handleSizeChange (pageSize) {
      this.requestParameters.pagesize = pageSize;
      if (this.requestParameters.page === 1) {
      }
      this.getList(this.requestParameters);
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.requestParameters.currentpage = newPage;
      this.getList();
    },
    //清除kkkk
    handleClear () {
      this.inputAcount = ""
      this.customerId = ""
      this.isRenew = "",
      this.state = ""
      this.offlineStatus = "",
      this.onlineStatus = "",
      this.orderType = ''
      this.orderStatuss = '',
      this.createTimes = [],
      this.createTimess = [],
      this.createTimesss = [],
      this.customerIsallpay = "";
      this.searchWx = ""; // 清除查询内容
      this.searchStatus = ""; // 清除状态
      this.searchType = ""; // 清除类型
      this.searchStudent = ""; //学生姓名
      this.searchSourcesPeople = ""; //来源负责人
      this.searchSource = ""; //选择来源
      this.searchTeacherId = ""; //老师姓名
      this.regionName = ''
      this.trafficSource = ''

      this.regionNames = ''
      this.grade = []
      this.parentPhoneNumber = ''
      this.channelType = ''
      this.classType = ''

      this.getList(); //重新获取列表
    },
    // 搜索
    handleSearch () {
      this.requestParameters.currentpage = 1;
      this.getList();
    },

    handleSearch1(row,type){
        
      if(type === '1'){
        this.isnewModesCustomerFundingDetails = true
        this.isnewModesCustomerFundingDetailsDetail = false
        this.isnewModesCustomerFundingDetailsTitle = '新增分单'

        this.input1 = ''
        this.input2 = ''
        this.input3 = ''

        this.ids = ''
        this.urls = '/saleWeight/add'
        this.types = type

      }else if(type === '2'){
        this.isnewModesCustomerFundingDetails = true
        this.isnewModesCustomerFundingDetailsDetail = false
        this.isnewModesCustomerFundingDetailsTitle = '编辑分单'

        this.input1 = row.saleId
        this.input2 = row.saleWeight
        this.input3 = row.saleType

        this.ids = row.id
        this.urls = '/saleWeight/update'
        this.types = type

      }else if(type === '3'){
        this.isnewModesCustomerFundingDetails = true
        this.isnewModesCustomerFundingDetailsDetail = true
        this.isnewModesCustomerFundingDetailsTitle = '分单详情'

        this.input1 = row.saleId
        this.input2 = row.saleWeight
        this.input3 = row.saleType

        this.ids = row.id
        this.urls = '/saleWeight/update'
        this.types = type

      }else if(type === '4'){

        this.$confirm('确定要删除该条信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          axios.post(`${apiBaseUrl}/saleWeight/delete/${row.id}`,{},{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')  }}).then((res)=>{
            if(res.data.code == 200){
              this.$message({  type: 'success',  message: '删除成功!'   });
              this.getList()
              axios.post(`${apiBaseUrl}/schedule/teacherListByName`, { realname: '' },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(ress => {
                if (ress.data.code == 200) {
                  let datas = ress.data.data
                  this.optionsListss = datas
                }else{
                  this.optionsListss = JSON.parse(sessionStorage.getItem('customersaleObj1'))
                }
              })
            }else{
              this.$message.error(res.data.message || res.data.meg)
            }
          }).catch((error) => {
            this.$message.error(error)
          })
        }).catch(() => { });
       
      }
      
    },


    isnewModesCustomerFundingDetailscloseEditDialogs(){
      this.isnewModesCustomerFundingDetails = false
      this.input1 = ''
      this.input2 = ''
      this.input3 = ''
    },


    isnewModesCustomerFundingDetailsSibutleForm(){

        let data = { id: this.ids,  saleId: this.input1,  saleWeight: this.input2, saleType: this.input3,  }

        let datas = { saleId: this.input1,  saleWeight: this.input2, saleType: this.input3  }

        if(this.input1 && this.input2 && this.input3){
          axios.post(`${apiBaseUrl}${this.urls}`, this.types === '1' ? datas : data ,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
            if (res.data.code == 200) {
                this.isnewModesCustomerFundingDetails = false
                this.$message({ message: res.data.message || res.data.meg, type: "success", duration: 1000 });
                this.getList();

                axios.post(`${apiBaseUrl}/schedule/teacherListByName`, { realname: '' },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(ress => {
                  if (ress.data.code == 200) {
                    let datas = ress.data.data
                    this.optionsListss = datas
                  }else{
                    this.optionsListss = JSON.parse(sessionStorage.getItem('customersaleObj1'))
                  }
                })
            }else{
                this.$message({ message: res.data.message || res.data.meg, type: "error", duration: 1000 });
            }
          }).catch(error => {
            this.$message({ message: error,  type: "error"  });
          })
        }else{
          this.$message.warning('请填写完整信息')
        }
    },


    //修改学生弹窗
    showEditDialog () {
      this.edit(); // 在打开编辑弹层时调用获取数据的方法
      this.showEdit = true;
    },
    closeEditDialog () {
      this.showEdit = false;
    },
    // 编辑表单
    saveEditForm () {
      // 保存编辑表单的逻辑
      // 将编辑后的数据提交给后端 API
      // ...
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstudentupdate`, {
          customerStudent: this.studentName,
          customerId: this.customerId,
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "修改成功",
              type: "success",
              duration: 1000,
            });
            this.showEdit = false;
            this.getList();
          } else {
            this.$message({ error: "修改失败", type: "error", duration: 1000 });
          }
        })
        .catch(
          (error) =>
            function () {
              this.$message({
                error: "修改失败",
                type: "error",
                duration: 1000,
              });
            }
        );
    },
    refreshOrder () {
      this.getList();
    },
    newModesCustomerFundingDetailEvent(){
      this.isnewModesCustomerFundingDetail = false
      this.getList()
    },
    edit (customerId) {
      this.isnewModesCustomerFundingDetail = true
      this.$nextTick(() => {
        // this.$refs.orderUpdate.init(customerId);

        this.$refs.newModesCustomerFundingDetail.init(customerId,1);
      });
    },
    detail (customerId) {
      this.isnewModesCustomerFundingDetail = true
      this.$nextTick(() => {
        // this.$refs.orderDetail.init(customerId);

        this.$refs.newModesCustomerFundingDetail.init(customerId,2);

      });
    },
    //回显学生姓名并修改
    getStudent () {
      const data = {
        customerStudent: "",
        customerId: "",
      };
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstudentupdate${data}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //成交状态
    handleChangeType (customer) {
      this.$confirm(
        `确定修改客资成交状态吗？<span style="color: red">成交状态只可修改一次!</span>`,
        `提示`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          this.$refs.orderUpdate.orderShow(customer);
        })
        .catch(() => {
          customer.type = 1;
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //导出客资
    handleDownload () {
      // 定义要传递的参数
      // const params = {
      //   customerStudent: "", // 姓名
      //   customerAccount: "", //账号
      //   customerWx: this.searchWx, //要查询的微信号
      //   customerState: this.searchStatus, //选择状态
      //   customerIsactive: this.searchAdd, //选择添加方式
      //   customerType: this.searchType,
      //   type: 2,
      // };
      const params = {
        classType: this.classType,
        customerId: this.customerId,
        isRenew: this.isRenew,
        offlineStatus: this.offlineStatus,
        onlineStatus: this.onlineStatus,
        customerIsallpay: this.customerIsallpay,
        customerPaytime: this.customerPaytime,
        page: this.requestParameters.currentpage,
        limit: this.requestParameters.pagesize,
        studentName: this.searchStudent, //要查询的学生姓名
        teacherId: this.searchTeacherId,
        customerAccount: "",
        customerWx: this.searchWx, //要查询的微信号
        searchSource: this.searchSource, //来源
        searchSourcesPeople: this.searchSourcesPeople,
        customerType: this.searchType,
        type: 2,
        orderType: this.orderType,
        createTimes: this.createTimes,
        paymentTime: this.paymentTime,
        orderStatus: this.orderStatuss,
        account:this.inputAcount,
        state:this.state,

        // startPayTime:this.createTimess.length > 0 ? this.createTimess[0] : '',
        // endPayTime:this.createTimess.length > 0 ? this.createTimess[1] : '',
        // startAllpayTime:this.createTimesss.length > 0 ? this.createTimesss[0] : '',
        // endAllpayTime:this.createTimesss.length > 0 ? this.createTimesss[1] : '',

        returnStartDate:this.createTimess.length > 0 ? this.createTimess[0] : '',
        returnEndDate:this.createTimess.length > 0 ? this.createTimess[1] : '',
        returnCreateStartDate:this.createTimesss.length > 0 ? this.createTimesss[0] : '',
        returnCreateEndDate:this.createTimesss.length > 0 ? this.createTimesss[1] : '',


        regionName:this.regionName || localStorage.getItem('cityTepy'),
        trafficSource:this.trafficSource,
        gradeList: this.grade.lenght > 0 ? this.grade : [],
        parentPhoneNumber: this.parentPhoneNumber,
        channelType: this.channelType,
        returnPremiumType: this.orderStatuss,

        projectTeacherId: this.searchSourcesPeople111,
        diagnoseTeacherId: this.searchSourcesPeople11,

      };
      //点击客资管理显示您好，xx老师
      let admin = window.localStorage.getItem("admin");
      if (admin != null) {
        params.customerAccount = JSON.parse(admin).adminNo;
      } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          params.customerAccount = JSON.parse(teacher).adminNo;
        }
      }

      // params.customerAccount = this.inputAcount
      axios
        .post(
          `${apiBaseUrl}/orderCustomer/exportListReturn`,
          params,
          { responseType: "blob",
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }  // 设置responseType为'blob'以接收二进制数据
        )
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          }); // 从响应中获取Blob对象
          const downloadLink = document.createElement("a"); // 创建一个下载链接
          downloadLink.href = URL.createObjectURL(blob); // 设置下载链接的URL为Blob对象的URL
          downloadLink.download = "退费客资信息.xlsx"; // 设置下载文件的文件名
          // console.log(response);

          downloadLink.click(); // 触发下载
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //点击添加客资跳转客资收集
    addCustomer () {
      this.$router.push("/customercollect");
    },
  },
};
</script>

<style scoped>
.demo-form-inline {
  flex-wrap: wrap;
  display: flex;
}

/* .demo-form-inline .el-form-item {
  margin-right: 30px;
} */

.cor {
  border-radius: 5px;
  margin-top: 10px;
  background-color: #f4f4f5;
}

.num {
  padding: 10px;
  color: #ccc;
  font-size: 13px;
}

.el-icon-info {
  margin-right: 5px;
}



.page {
  position: fixed;
  bottom: 0;
  width: 80%;
}

.custom-dialog {
  overflow: auto;
}

.parent-container {
  position: relative;
}

.pagination-container {
  position: absolute;
  bottom: 10px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.el-dialog {
    width: 70% !important;
  }
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/CustomerFundingAll/SplitOrderManagemen.vue